import { render, staticRenderFns } from "./SubmitStep.vue?vue&type=template&id=246dab50&"
import script from "./SubmitStep.vue?vue&type=script&lang=js&"
export * from "./SubmitStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports